import {Dto} from '../../../../common/src/lib/dtos/dto';

export class UnpackProtocolActivityRepMeasurementDto extends Dto {
    deviceType: string;
    bodyPartSide: string;
    bodyPart: string;
    protocolType: string;
    serialCode: string;

    deltas: number[];
    channel1Forces: number[];
    channel2Forces: number[];
    channel3Forces: number[];
    channel4Forces: number[];
    channel5Forces: number[];
    channel6Forces: number[];
    channel7Forces: number[];
    channel8Forces: number[];
    channel9Forces: number[];
    channel10Forces: number[];
    channel11Forces: number[];
    channel12Forces: number[];
    channel13Forces: number[];
    channel14Forces: number[];
    channel15Forces: number[];
    channel16Forces: number[];
    channel17Forces: number[];

    public deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
